
class MitKeyTypeService {
  constructor() {
      this.KEY_TYPES = {
        great_grand_master_key:{
              name: 'Great Grand Master Key',
              id: 'great_grand_master_key'
        },
        grand_master_key:{
              name: 'Grand Master Key',
              id: 'grand_master_key'
        },
        master_key:{
              name: 'Master Key',
              id: 'master_key'
        },
        change_key: {
              name: 'Change Key',
              id: 'change_key'
        }
      };
      this.KEY_TYPES_DEFAULT = this.KEY_TYPES.change_key;
      this.KEY_TYPES_ARRAY = [];//array version, helper for things like selection boxes that need an array.

      for(let k in this.KEY_TYPES){
        this.KEY_TYPES_ARRAY.push(this.KEY_TYPES[k]);
      }

  }


}

export default MitKeyTypeService;
